import { render, staticRenderFns } from "./UploaderAudio.vue?vue&type=template&id=25a948a8&"
import script from "./UploaderAudio.vue?vue&type=script&lang=ts&"
export * from "./UploaderAudio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports